import React from 'react';
import { graphql, useStaticQuery } from "gatsby";
import Main from "../Layout/Main";
import { Helmet } from 'react-helmet';
import CoverImage from '../CoverImage';
import TextBlock from '../TextBlock/TextBlock';
import PressQuotes from '../PressQuotes/PressQuotes';
import PhotoGrid from '../PhotoGrid';
import LargeEditorial from '../LargeEditorial';
import SmallBoxes from '../SmallBoxes/SmallBoxes';
import ImageBlocks from '../ImageBlocks';
import Carousel from  '../Carousel/Carousel';
import EditorialPortrait from '../EditorialPortrait';

const Ram = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query RamQuery {
      markdownRemark(frontmatter: { pageId: { eq: "ram-page" } }) {
        frontmatter {
          components {
            type
            id
            deeplink
            variant
            content {
              logo {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              videoSlides {
                video {
                  src
                  loop
                  autoplay
                  controls
                  caption
                }
              }
              video {
                src
                loop
                autoplay
                controls
              }
              gridImages {
                caption
                featured
                image {
                  childImageSharp {
                    fluid(maxWidth: 2048, quality: 80) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                  extension
                  publicURL
                }
              }
              copy {
                leader
                caption
                trailer
                quotes {
                  line
                  source
                  socialIcons {
                    icon
                  }
                }
                body {
                  line
                }
                subheads {
                  line
                }
                headlines {
                  line
                }
                scriptHeadline {
                  line
                }
                blocks {
                  headline
                  body2 {
                    line
                  }
                  leader
                  headline2
                  bullets {
                    bullet
                  }
                  body {
                    line
                  }
                  type
                  image
                  icon {
                    childImageSharp {
                      fluid(maxWidth: 2048, quality: 80) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                    extension
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const availComponents = {
    CoverImage,
    TextBlock,
    PressQuotes,
    PhotoGrid,
    LargeEditorial,
    SmallBoxes,
    ImageBlocks,
    Carousel,
    EditorialPortrait
  }

  const renderComponents = () => {
    const components = markdownRemark.frontmatter.components;
    let hydratedComponents = [];
    components.forEach((component, i) => {
      // console.log(component.type, component.content)
      const ComponentRef = availComponents[component.type];
      const deeplinkId = component.deeplink ? component.id : '';
      hydratedComponents.push(<ComponentRef key={i} id={deeplinkId} variant={component.variant} {...component.content}/>)
    })
    return hydratedComponents
  }

  return (
    <Main>
      <Helmet>
        <body className="page ram-page" />
      </Helmet>
      {renderComponents()}
    </Main>
  );
}

export default Ram
